import { render, staticRenderFns } from "./BudgetDepartamentTable.vue?vue&type=template&id=027f9738&scoped=true"
import script from "./BudgetDepartamentTable.vue?vue&type=script&lang=js"
export * from "./BudgetDepartamentTable.vue?vue&type=script&lang=js"
import style0 from "./BudgetDepartamentTable.vue?vue&type=style&index=0&id=027f9738&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "027f9738",
  null
  
)

export default component.exports